import {
  FETCH_WOUND_REPORT,
  FETCH_WOUND_REPORT_SUCCESS,
  FETCH_WOUND_REPORT_FAILURE,
} from "./constants";

// Fetch the home-level report — payload: { locationId, from, to }.
// `from`/`to` are YYYY-MM-DD; the API snaps both to month boundaries and
// defaults to the last 12 whole months.
export const fetchWoundReport = (payload, onSuccess) => ({
  type: FETCH_WOUND_REPORT,
  payload,
  onSuccess,
});
export const fetchWoundReportSuccess = (payload) => ({
  type: FETCH_WOUND_REPORT_SUCCESS,
  payload,
});
export const fetchWoundReportFailure = (payload) => ({
  type: FETCH_WOUND_REPORT_FAILURE,
  payload,
});
